module.exports = __webpack_public_path__ + "static/tt-map-marker-v2-3cf88176685da8d5fe0a4c539ff23a5a.png";